import React, {
    useCallback, useEffect
} from 'react';
import _ from 'lodash';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { PremierConstants } from 'premier-constant-service';															
import { useUpdateSubmissionServices, validationUtil } from 'premier-capability-hooks';
import { withRouter } from 'react-router-dom';
import presentationMetadata from "gw-capability-gateway-quoteandbind-PremierPL-react/config/PremierPL-wizard-config.json5";
import metadata from './AccountantPage.metadata.json5';
import styles from './AccountantPage.module.scss';
import ProductCoverageSelectionComponent from "../../components/Accountant/ProductCoverageSelection/ProductCoverageSelectionComponent";
import BusinessOperationComponent from "../../components/Accountant/BusinessOperation/BusinessOperationComponent";
import RevenuesComponent from "../../components/Accountant/Revenue/RevenueComponent";
import OperationsComponent from "../../components/Accountant/Operations/OperationsComponent";
import AdditionalInformationComponent from "../../components/Accountant/AdditionalInformation/AdditionalInformationComponent";
import UnderwritingInformationComponent from "../../components/Accountant/UnderwritingInformation/UnderwritingInformationComponent";
import InsuranceHistoryComponent from "../../components/Accountant/InsuranceHistory/InsuranceHistoryComponent";

function AccountantPage(props) {

    const { wizardData: submissionVM, updateWizardData, changeNextSteps, steps } = props;
    const { updateSubmission } = useUpdateSubmissionServices();
    const propertySteps = _.filter(_.get(presentationMetadata, [`${submissionVM.value.baseData.productCode}.default.wizard`, 'steps']), (wizardStep) => wizardStep.id.includes('property') || wizardStep.id.includes('propertyCoverages'))
    const { lineName } = PremierConstants;
    const offeringCoverablePath = 'lobData.proLine.coverables.accountantCoverable.'

    const {
        onValidate,
        initialValidation
    } = useValidation('ArchitectEngineersPage');


    useEffect(() => {

    }, []);

    const onNext = useCallback(
        async () => {

            if (!_.isUndefined(submissionVM.value.lobData.proLine.coverables.accountantCoverable.productCoverageSelection.pro5)
                && submissionVM.value.lobData.proLine.coverables.accountantCoverable.productCoverageSelection.pro5) {
                if (_.filter(steps, (step) => step.id === 'property').length === 0) {
                    steps.splice(5, 0, propertySteps[0], propertySteps[1]);

                    if(_.get(submissionVM.value, 'baseData.jobType') === 'Submission') {
                        changeNextSteps(steps.slice(4, 13))
                    } else {
                        changeNextSteps(steps.slice(3, 13))
                    }
                    
                }
            } else {
                // eslint-disable-next-line no-lonely-if
                if (_.filter(steps, (step) => step.id === 'property').length !== 0) {
                    if(_.get(submissionVM.value, 'baseData.jobType') === 'Submission') {
                        changeNextSteps(_.filter(steps, (step) => !step.id.includes('property')).slice(4, 12))
                    } else {
                        changeNextSteps(_.filter(steps, (step) => !step.id.includes('property')).slice(3, 12))
                    }
                }
            }

            const productCode = _.get(submissionVM.value, 'baseData.productCode');
            // eslint-disable-next-line security/detect-object-injection
            const lobLineName = productCode ? lineName[productCode] : '';
            const response = await updateSubmission(lobLineName, 'AccountantPage', submissionVM);

            submissionVM.value = response;

            return submissionVM;
        },
        [changeNextSteps, lineName, propertySteps, steps, submissionVM, updateSubmission]
    );

    const onSave = useCallback(
        async () => {
            const subVMCopy = _.clone(submissionVM);
            const productCode = _.get(subVMCopy.value, 'baseData.productCode');
            
            validationUtil.unSetIsValidationReqFlag(subVMCopy?.lobData?.proLine?.coverables?.accountantCoverable?.value, ' ');

            const lobLineName = productCode ? lineName[productCode] : '';
            
            await updateSubmission(lobLineName, 'AccountantPage', subVMCopy);
            
            return submissionVM;
        },
        [lineName, submissionVM, updateSubmission]
    );

    const overrideProps = {
        productCoverageSelectionComponent: {
            submissionVM,
            updateWizardData,
            pathUpdated: `${offeringCoverablePath}productCoverageSelection`
        },
        businessOperationComponent: {
            submissionVM,
            updateWizardData,
            pathUpdated: `${offeringCoverablePath}businessOperation`
        },
        revenuesComponent: {
            submissionVM,
            updateWizardData,
            pathUpdated: `${offeringCoverablePath}revenue`
        },
        operationsComponent: {
            submissionVM,
            updateWizardData,
            pathUpdated: `${offeringCoverablePath}operations`
        },
        additionalInformationComponent: {
            submissionVM,
            updateWizardData,
            pathUpdated: `${offeringCoverablePath}additionalInformation`
        },
        underwritingInformationComponent: {
            submissionVM,
            updateWizardData,
            pathUpdated: `${offeringCoverablePath}underwritingInformation`
        },
        insuranceHistoryComponent: {
            visible: false,
            submissionVM,
            updateWizardData,
            pathUpdated: `${offeringCoverablePath}insuranceHistory`
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            productCoverageSelectionComponent: ProductCoverageSelectionComponent,
            businessOperationComponent: BusinessOperationComponent,
            revenuesComponent: RevenuesComponent,
            operationsComponent: OperationsComponent,
            additionalInformationComponent: AdditionalInformationComponent,
            underwritingInformationComponent: UnderwritingInformationComponent,
            insuranceHistoryComponent: InsuranceHistoryComponent
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.pageContent, submissionVM, id, path, overrideProps),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [metadata.pageContent, submissionVM, overrideProps]
    );


    const isDisableNext = () => !submissionVM.lobData.proLine.coverables.accountantCoverable.aspects.subtreeValid

    return (
        <WizardPage onNext={onNext} onSave={onSave} skipWhen={initialValidation} disableNext={isDisableNext()}>
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                onModelChange={updateWizardData}
                overrideProps={overrideProps}
                onValidationChange={onValidate}
                resolveValue={readValue}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
            />
        </WizardPage>
    );
}

AccountantPage.propTypes = wizardProps;
export default withRouter(AccountantPage);